export default "__VITE_ASSET__OFZOUfxifiFQJ1R3kVJviA__"